<template>
  <card :title="$t('gc-delays:delays')">
    <small slot="card-header-right" class="text-muted font-italic">{{ $t('gc-delays:required') }}</small>

    <div slot="card-body">
      <div class="form-row">
        <div class="form-group col-lg-6">
          <label for="networkMaxDelayUp" class="control-label">{{ $t('gc-delays:networkMaxDelayUp') | capitalize }} *</label>
          <input id="networkMaxDelayUp"
                 v-model="networkMaxDelayUp"
                 v-validate="'required|number|decimal:0|between:0,15000'"
                 :class="{ 'is-invalid': errors.has('networkMaxDelayUp') }"
                 :data-vv-as="$t('gc-delays:networkMaxDelayUp')"
                 name="networkMaxDelayUp"
                 type="text"
                 class="form-control"
          >
          <small class="form-text text-muted">{{ $t('gc-delays:networkMaxDelayUpUnit') | capitalize }}</small>
          <div class="invalid-feedback">{{ errors.first('networkMaxDelayUp') }}</div>
        </div>

        <div class="form-group col-lg-6">
          <label for="networkMaxDelayDown" class="control-label">{{ $t('gc-delays:networkMaxDelayDown') | capitalize }} *</label>
          <input id="networkMaxDelayDown"
                 v-model="networkMaxDelayDown"
                 v-validate="'required|number|decimal:0|between:0,15000'"
                 :data-vv-as="$t('gc-delays:networkMaxDelayDown')"
                 :class="{ 'is-invalid': errors.has('networkMaxDelayDown') }"
                 name="networkMaxDelayDown"
                 type="text"
                 class="form-control"
          >
          <small class="form-text text-muted">{{ $t('gc-delays:networkMaxDelayDownUnit') | capitalize }}</small>
          <div class="invalid-feedback">{{ errors.first('networkMaxDelayDown') }}</div>
        </div>
      </div>
    </div>

    <div slot="card-footer">
      <button id="sendButton" class="btn btn-primary" @click="send">{{ $t('gc-delays:send') }}</button>
    </div>
  </card>
</template>

<script>
import { pick } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      set: false,
      networkMaxDelayUp: '',
      networkMaxDelayDown: ''
    }
  },

  computed: {
    ...mapGetters(['gateway'])
  },

  watch: {
    async eui () {
      // Reset data, and get data from new gateway
      this.set = false
      this.networkMaxDelayUp = ''
      this.networkMaxDelayDown = ''

      // Reset form validation
      await this.$nextTick()
      this.$validator.reset()
    },

    gateway () {
      if (!this.set) { // only set the current gateway if it is not already done
        this.networkMaxDelayUp = this.gateway.networkMaxDelayUp
        this.networkMaxDelayDown = this.gateway.networkMaxDelayDown
        this.set = true
      }
    }
  },

  created () {
    // always set properties on created
    this.networkMaxDelayUp = this.gateway.networkMaxDelayUp
    this.networkMaxDelayDown = this.gateway.networkMaxDelayDown

    if (this.gateway.eui === this.eui) { // mark properties as set for the current gateway
      this.set = true
    }
  },

  methods: {
    async send () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      const keys = ['networkMaxDelayUp', 'networkMaxDelayDown']
      let error
      [error] = await to(this.$api.patchGateway(this.gateway, pick(this, keys)))
      if (!error) eventBus.$emit('message-success', this.$t('gc-delays:sendSuccess'))
    }
  }
}
</script>
